import {NestModalOptions} from "./nest-modal.interfaces";
import {HTMLStencilElement} from "@stencil/core/internal";

export interface HTMLModalElement extends HTMLStencilElement {}

export class NestModalController {
  private container: HTMLElement | null = null
  private preQueue: HTMLModalElement[] = []
  private queue: HTMLModalElement[] = [];
  private queueLimit: number = 6;

  tag = 'nest-modal'

  constructor() {}

  public create(options: NestModalOptions): any {
    this.setupContainer();

    const el: any = document.createElement(this.tag) as unknown;

    Object.assign(el, { data: options});

    this.preQueue.push(el);

    if (this.queue.length < this.queueLimit) {
      const el = this.preQueue.shift()
      if (el && this.container) {
        this.queue.push(el)
        this.container.insertAdjacentElement('beforeend', el)
      }
    }
    if (this.queue.length === 0) {
      this.container?.remove()
    }

    console.log('Create Modal', options, this.preQueue);
  }

  async dismissAll(): Promise<void> {
    const elements = this.container?.querySelectorAll(this.tag)
    if (elements) {
      const closingQueue = []
      for (let index = 0; index < elements.length; index++) {
        const el: any = elements[index] as unknown as HTMLModalElement
        if (el.close) {
          closingQueue.push(el.close())
        }
      }
      this.queue = [];
      await Promise.all(closingQueue)
    }
  }

  private setupContainer() {
    const containerId = `nest-notices-container`
    this.container = document.getElementById(containerId)

    if (this.container) return

    if (!this.container) {
      this.container = document.createElement('nest-notices')
      this.container.setAttribute('interface', this.tag.replace('nest-', ''))
      this.container.id = containerId
    }

    document.body.appendChild(this.container)
  }
}

export const nestModalController = new NestModalController()
